import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import SignalCellularConnectedNoInternet4BarIcon from '@mui/icons-material/SignalCellularConnectedNoInternet4Bar';
import SensorsIcon from '@mui/icons-material/Sensors';
import SecurityIcon from '@mui/icons-material/Security';

import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import InputAdornment from '@mui/material/InputAdornment';
import React, { useState, useMemo, useEffect, useCallback, useRef } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import AppBar from '@mui/material/AppBar';


import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { Stomp } from '@stomp/stompjs';

import Close from '@material-ui/icons/Close'
import { Snackbar } from '@material-ui/core';
import { Menu } from '@mui/material';
import CabecalhoInformacoes from '../components/CabecalhoInformacoes/index'

import Cookies from 'js-cookie';
import { MenuItem, Select, InputLabel, FormControl, IconButton, Tooltip } from '@mui/material';
import {
    FormLabel,
    RadioGroup,
    Radio,
} from '@material-ui/core';

import { useHistory } from "react-router-dom";
import moment from 'moment';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Box } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';

import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import './styles.css';


import {
    MaterialReactTable
} from 'material-react-table';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import MuiPaper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import CallIcon from '@mui/icons-material/Call';

import BuildIcon from '@mui/icons-material/Build';
import Switch from '@mui/material/Switch';
import SettingsIcon from '@mui/icons-material/Settings';
import PowerIcon from '@mui/icons-material/Power';
import PowerOffIcon from '@mui/icons-material/Power';



import api from '../../../../../services/api';


import NavegadorGestao from "../../../../../components/NavBarGestao";
import PainelInstalacaoDetalhes from '../components/PainelInstalacaoDetalhes/index';
import GraficoDisponibilidade from '../../../../../components/GraficoDisponibilidade/GraficoDisponibilidade';
import JsSIP from 'jssip';


import switch_off from '../../../../../assets/imgs/switch-off.png';
import switch_on from '../../../../../assets/imgs/switch-on.png';


import mini_icone_carro from '../../../../../assets/imgs/mini_icone_carro.png';

import mini_icone_moto from '../../../../../assets/imgs/mini_icone_moto.png';
import icone_local_protegido from '../../../../../assets/imgs/icone_local_protegido.png';

import icone_origem from '../../../../../assets/imgs/icone_origem.png';
import icone_destino from '../../../../../assets/imgs/icone_destino.png';
import icone_parada from '../../../../../assets/imgs/icone_parada.png';


import icone_pgm from '../../../../../assets/imgs/icone_pgm.png';
import icone_corneta from '../../../../../assets/imgs/corneta.png';

import icone_play from '../../../../../assets/imgs/play.png';


import icone_medidor from '../../../../../assets/imgs/icone_medidor.png';

import icone_subestacao from '../../../../../assets/imgs/icone_subestacao.png';
import icone_casa from '../../../../../assets/imgs/icone_casa.png';
import icone_loja from '../../../../../assets/imgs/icone_loja.png';
import icone_central from '../../../../../assets/imgs/icone_central.png';

import icone_instalacoes from '../../../../../assets/imgs/icone_instalacoes.png';
import icone_equipamentos from '../../../../../assets/imgs/icone_equipamentos.png';

import icone_armar_stay from '../../../../../assets/imgs/armar_stay.png';
import icone_armar_away from '../../../../../assets/imgs/armar_away.png';
import icone_desarmar from '../../../../../assets/imgs/desarmar.png';
import globalConfig from '../../../../../configs/globalConfigs';


import "./MapPage.css";
import MapaDoLocal from './mapaLocal.js';
import alarmeAudio from '../../../../../assets/mp3/alarme.mp3';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        height: '1000px',

        backgroundColor: 'white',
    },
    toolbar: {

    },
    toolbarIcon: {

    },
    appBar: {

    },
    appBarShift: {

    },
    menuButton: {

    },
    menuButtonHidden: {

    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {

    },
    drawerPaperClose: {

    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        display: 'flex',


    },
    container: {
        display: 'flex',
        height: '1000px',

        backgroundColor: 'green',


    },
    paper: {

    },
    fixedHeight: {

    },
}));


const libraries = ["places"];


// Gerenciador de Áudio (Singleton)
const audioManager = {
    audio: new Audio(alarmeAudio),
    isPlaying: false,
    play() {
        if (!this.isPlaying) {
            this.audio.loop = true;
            this.audio.volume = 1.0;
            this.audio
                .play()
                .then(() => {
                    this.isPlaying = true;
                })
                .catch(error => console.error("Erro ao reproduzir o áudio:", error));
        }
    },
    pause() {
        if (this.isPlaying) {
            this.audio.pause();
            this.audio.currentTime = 0;
            this.isPlaying = false;
        }
    }
};


function extrairInstalacoes(payload) {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (payload.instalacoes && Array.isArray(payload.instalacoes)) return payload.instalacoes;
    if (payload.data && Array.isArray(payload.data)) return payload.data;
    return [];
}

export default function MonitoramentoMosaico() {
    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode') || Cookies.get('tema');
        return saved === 'true' || saved === 'dark';
    });
    useEffect(() => {
        const handleThemeChange = (e) => {
            const saved = Cookies.get('darkMode') || Cookies.get('tema');
            setDarkMode(saved === 'true' || saved === 'dark');
        };
        window.addEventListener('darkModeChanged', handleThemeChange);
        return () => window.removeEventListener('darkModeChanged', handleThemeChange);
    }, []);
    const audioRef = useRef(new Audio(alarmeAudio)); // Inicializar o ref com o áudio importado
    const tempoInativo = 3;

    const [pgmsArmadas, setPgmsArmadas] = useState(0);
    const [pgmsDesarmadas, setPgmsDesarmadas] = useState(0);
    const [pgmsOfflines, setPgmsOfflines] = useState(0);
    const [pgmsAlarmadas, setPgmsAlarmadas] = useState(0);



    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    const classes = useStyles();
    const history = useHistory();


    const [value, setValue] = React.useState(0);
    const [isHoveringNav, setIsHoveringNav] = useState(false);





    const [instalacaoSelecionada, setInstalacaoSelecionada] = useState(null);
    const instalacaoSelecionadaRef = useRef(instalacaoSelecionada); // Inicialize a ref com o valor inicial do estado
    const [mapPosition, setMapPosition] = useState(null);
    const mapPositionRef = useRef(null);

    // Atualize a referência sempre que o estado mudar
    useEffect(() => {
        instalacaoSelecionadaRef.current = instalacaoSelecionada;
        if (instalacaoSelecionada) {
            const newMapPosition = {
                lat: parseFloat(instalacaoSelecionada.latitude),
                lng: parseFloat(instalacaoSelecionada.longitude),
            };

            // Verifica se o valor atual é diferente do armazenado na ref
            if (
                !mapPositionRef.current ||
                mapPositionRef.current.lat !== newMapPosition.lat ||
                mapPositionRef.current.lng !== newMapPosition.lng
            ) {
                setMapPosition(newMapPosition);
                mapPositionRef.current = newMapPosition; // Atualiza a ref com a nova posição
            }
        }
    }, [instalacaoSelecionada]);

    function returnDescricaoEndereco(objeto) {
        if (!objeto) return "";
        return `${objeto.endereco}, ${objeto.numero} - ${objeto.bairro}, ${objeto.cidade} - ${objeto.estado}, ${objeto.cep}`;
    }

    async function handleInstalacaoSelecioanada(instalacao) {
        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("/v1/protected/cliente/instalacoes/listarporid/" + instalacao.id_instalacao, {
                headers: headers
            }).then(function (response) {
                setInstalacaoSelecionada(response.data)

            });

        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }
    }


    const [showTable, setShowTable] = useState(true);
    const [openGraficoDisponibilidade, setOpenGraficoDisponibilidade] = useState(false);

    // --- SIP LOGIC IN MOSAICO ---
    const [sipUA, setSipUA] = useState(null);
    const [sipStatus, setSipStatus] = useState('Disconnected');
    const [sipSession, setSipSession] = useState(null);
    const [activeCallRamal, setActiveCallRamal] = useState(null);
    const [isCallAnswered, setIsCallAnswered] = useState(false);
    const [callDuration, setCallDuration] = useState(0);
    const [isMuted, setIsMuted] = useState(false);
    const remoteAudioRefMosaico = useRef(null);

    const sipDomain = 'gruporosinetos.com';
    const sipUser = 'webrtc';
    const sipPassword = '1234';
    const socketUrl = 'wss://gruporosinetos.com/ws';

    useEffect(() => {
        let interval = null;
        if (activeCallRamal) {
            interval = setInterval(() => {
                setCallDuration(prev => prev + 1);
            }, 1000);
        } else {
            setCallDuration(0);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [activeCallRamal]);

    const handleSipHangup = useCallback(() => {
        if (sipSession) {
            try {
                sipSession.terminate();
            } catch (e) {
                console.warn('[MOSAICO SIP] Error terminating session:', e);
            }
        }
        setSipSession(null);
        setActiveCallRamal(null);
        setIsCallAnswered(false);
        setIsMuted(false);
        setCallDuration(0);
    }, [sipSession]);

    const handleToggleMute = useCallback(() => {
        if (sipSession) {
            try {
                if (isMuted) {
                    sipSession.unmute({ audio: true });
                    setIsMuted(false);
                } else {
                    sipSession.mute({ audio: true });
                    setIsMuted(true);
                }
            } catch (e) {
                console.warn('[MOSAICO SIP] Error toggling mute:', e);
            }
        }
    }, [sipSession, isMuted]);

    const handleSendDTMF = useCallback((tone) => {
        if (sipSession) {
            try {
                sipSession.sendDTMF(tone);
            } catch (err) {
                console.warn('[MOSAICO SIP] sendDTMF error:', err);
            }
        }
    }, [sipSession]);

    const handleSipCall = useCallback((targetRamal) => {
        if (!targetRamal) return;

        if (!sipUA || !sipUA.isRegistered()) {
            alert('Sistema SIP não registrado ou conectando. Por favor, aguarde a conexão.');
            return;
        }

        if (sipSession) {
            handleSipHangup();
        }

        console.log('[MOSAICO SIP] Calling:', targetRamal);
        const options = {
            mediaConstraints: { audio: true, video: false },
            pcConfig: { iceServers: [{ urls: ['stun:stun.l.google.com:19302'] }] }
        };

        try {
            const session = sipUA.call(`sip:${targetRamal}@${sipDomain}`, options);
            setSipSession(session);
            setActiveCallRamal(targetRamal);
            setIsCallAnswered(false);
            setIsMuted(false);
            setCallDuration(0);

            session.on('peerconnection', (data) => {
                const pc = data.peerconnection;
                pc.addEventListener('track', (event) => {
                    const [remoteStream] = event.streams;
                    if (remoteAudioRefMosaico.current) {
                        remoteAudioRefMosaico.current.srcObject = remoteStream;
                        remoteAudioRefMosaico.current.play().catch(err => {
                            console.warn('[MOSAICO SIP] Audio play prevented by browser:', err);
                        });
                    }
                });
            });

            session.on('confirmed', () => {
                setIsCallAnswered(true);
            });

            session.on('ended', () => {
                setSipSession(null);
                setActiveCallRamal(null);
                setIsCallAnswered(false);
                setIsMuted(false);
                setCallDuration(0);
            });

            session.on('failed', (e) => {
                console.error('[MOSAICO SIP] Call Failed:', e.cause);
                setSipSession(null);
                setActiveCallRamal(null);
                setIsCallAnswered(false);
                setIsMuted(false);
                setCallDuration(0);
                alert(`Chamada não completada: ${e.cause || 'Erro na chamada'}`);
            });
        } catch (err) {
            console.error('[MOSAICO SIP] Call exception:', err);
            alert(`Erro ao iniciar chamada: ${err.message}`);
        }
    }, [sipUA, sipSession, handleSipHangup, sipDomain]);

    useEffect(() => {
        if (sipUA) return;

        const socket = new JsSIP.WebSocketInterface(socketUrl);
        const configuration = {
            sockets: [socket],
            uri: `sip:${sipUser}@${sipDomain}`,
            password: sipPassword,
            display_name: 'Mosaico WebRTC',
            register: true,
            session_timers: false
        };

        const newUa = new JsSIP.UA(configuration);

        newUa.on('connecting', () => setSipStatus('Connecting...'));
        newUa.on('connected', () => setSipStatus('Connected'));
        newUa.on('disconnected', () => setSipStatus('Disconnected'));
        newUa.on('registered', () => setSipStatus('Registered'));
        newUa.on('registrationFailed', (e) => setSipStatus(`Error: ${e.cause}`));

        newUa.start();
        setSipUA(newUa);

        return () => {
            try {
                newUa.stop();
            } catch (e) {}
        };
    }, [socketUrl, sipUser, sipDomain, sipPassword]);

    const [definingPerimeter, setDefiningPerimeter] = useState(false); // Indica se está definindo perímetros
    const [perimeterPoints, setPerimeterPoints] = useState([]); // Armazena os pontos do perímetro
    const [currentPerimeter, setCurrentPerimeter] = useState(1); // Controla qual perímetro está sendo definido (P1 a P4)





    const [endereco, setEndereco] = useState();

    const [instalacoes, setInstalacoes] = useState([]);
    const { instalacoesEnriquecidas, snapshot } = useMemo(() => {
        if (!instalacoes || !Array.isArray(instalacoes)) {
            return {
                instalacoesEnriquecidas: [],
                snapshot: {
                    total_instalacoes: 0,
                    total_protegidas: 0,
                    total_desarmadas: 0,
                    total_desconectadas: 0,
                    total_em_alarme: 0
                }
            };
        }

        const now = Date.now();
        let prot = 0;
        let desar = 0;
        let desc = 0;
        let alar = 0;

        const processadas = instalacoes.map(inst => {
            let instAlarme = false;
            let instOnline = false;
            let instArmada = false;
            let codigoPgm = null;
            let dataHoraPgm = null;
            let codigoSonoro = null;
            let dataHoraSonoro = null;
            let temModuloSonoro = false;
            let ramalInstalacao = inst.ramal || null;

            const searchTokens = [
                String(inst.id_instalacao || ''),
                inst.nome_mapa || '',
                inst.identificador_integrador || '',
                inst.logradouro || '',
                inst.bairro || '',
                inst.cidade || ''
            ];

            if (inst.equipamentos && Array.isArray(inst.equipamentos)) {
                inst.equipamentos.forEach(eq => {
                    if (!eq) return;
                    const tipo = eq.tipo_equipamento_area_tecnica;
                    if (tipo === 0 && eq.modulo_pgm) {
                        const mod = eq.modulo_pgm;
                        if (mod.codigo) {
                            codigoPgm = mod.codigo;
                            searchTokens.push(String(mod.codigo));
                        }
                        if (mod.data_hora_ultima_resposta) {
                            dataHoraPgm = mod.data_hora_ultima_resposta;
                        }
                        if (!ramalInstalacao && mod.ramal) ramalInstalacao = mod.ramal;

                        const last = new Date(mod.data_hora_ultima_resposta);
                        const diffMin = (now - last) / 1000 / 60;
                        const eqAlarme = !!eq.alarme;
                        if (eqAlarme) instAlarme = true;
                        const eqOnline = eqAlarme || (diffMin < 3);
                        if (eqOnline) instOnline = true;

                        let countsAsArmed = !!mod.armada;
                        if (!mod.status_central && mod.status_zonas) {
                            countsAsArmed = (mod.status_zonas || "").split(";").some(l => {
                                const p = l.split(",");
                                if (p.length < 4) return false;
                                const s = (p[3] || "").toLowerCase().trim();
                                return s === "armada" || s === "true" || s === "1";
                            });
                        }
                        if (mod.status_central) {
                            const sc = mod.status_central.toLowerCase();
                            if (sc.includes("away") || sc.includes("stay")) {
                                countsAsArmed = true;
                            }
                        }
                        if (eqOnline && countsAsArmed) {
                            instArmada = true;
                        }
                    } else if (tipo === 30 && eq.modulo_sonoro) {
                        const mod = eq.modulo_sonoro;
                        temModuloSonoro = true;
                        if (mod.codigo) {
                            codigoSonoro = mod.codigo;
                            searchTokens.push(String(mod.codigo));
                        }
                        if (mod.data_hora_ultima_resposta) {
                            dataHoraSonoro = mod.data_hora_ultima_resposta;
                        }
                        if (!ramalInstalacao && mod.ramal) ramalInstalacao = mod.ramal;
                        const last = new Date(mod.data_hora_ultima_resposta);
                        const diffMin = (now - last) / 1000 / 60;
                        if (eq.alarme) instAlarme = true;
                        if (diffMin < 3) instOnline = true;
                    }
                    if (!ramalInstalacao && eq.ramal) {
                        ramalInstalacao = eq.ramal;
                    }
                });
            }

            if (ramalInstalacao) {
                searchTokens.push(String(ramalInstalacao));
            }

            let statusGeral = "DESARMADA";
            if (instAlarme) {
                statusGeral = "ALARME";
                alar++;
            } else if (!instOnline) {
                statusGeral = "DESCONECTADA";
                desc++;
            } else if (instArmada) {
                statusGeral = "PROTEGIDA";
                prot++;
            } else {
                statusGeral = "DESARMADA";
                desar++;
            }

            searchTokens.push(statusGeral);

            return {
                ...inst,
                status_geral: statusGeral,
                codigo_pgm: codigoPgm,
                data_hora_pgm: dataHoraPgm || inst.data_hora_ultima_resposta || null,
                codigo_sonoro: codigoSonoro,
                data_hora_sonoro: dataHoraSonoro,
                tem_modulo_sonoro: temModuloSonoro || Boolean(codigoSonoro || dataHoraSonoro),
                ramal: ramalInstalacao,
                search_index: searchTokens.join(' ').toLowerCase()
            };
        });

        return {
            instalacoesEnriquecidas: processadas,
            snapshot: {
                total_instalacoes: processadas.length,
                total_protegidas: prot,
                total_desarmadas: desar,
                total_desconectadas: desc,
                total_em_alarme: alar
            }
        };
    }, [instalacoes]);

    const formatarDataHora = useCallback((dataStr) => {
        if (!dataStr) return "Sem registro";
        const m = moment(dataStr);
        if (!m.isValid()) return String(dataStr);
        return m.format('DD/MM/YYYY HH:mm:ss');
    }, []);







    const [configuracoes, setConfiguracoes] = useState();
    const [loading, setLoading] = useState();
    const [loadingInstalacoes, setLoadingInstalacoes] = useState();

    async function listarInformacoes() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("/v1/protected/configuracoes", {
                headers: headers
            }).then(function (response) {
                setConfiguracoes(response.data);



                const logradouro = response.data.unidade_base.logradouro;
                const numero = response.data.unidade_base.numero;
                const bairro = response.data.unidade_base.bairro;
                const complemento = response.data.unidade_base.complemento;
                const cidade = response.data.unidade_base.cidade;
                const estado = response.data.unidade_base.estado;
                const cep = response.data.unidade_base.cep;

                const end = `${logradouro}, ${numero}, ${bairro}, ${cidade}, ${estado} - ${cep}`;
                setEndereco(end);
                console.log("Endereço: " + end);
                setLoading(false);


            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }




    function checkDimenssoes() {


        var largura = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

        setWidth(largura)

    }

    const [width, setWidth] = useState(0);



    window.addEventListener('resize', function (event) {
        checkDimenssoes();
    });


    useEffect(() => {


        listarInformacoes();


    }, []);








    function processarIcone(tipo) {
        if (tipo === 0) {
            return icone_pgm;
        } else if (tipo === 10) {
            return icone_medidor;
        } else if (tipo === 70) {
            return icone_central;
        } else if (tipo === 30) {
            return icone_pgm;
        } else if (tipo === 120) {
            return icone_corneta;
        }
    }



    function processarIconeInstalacao(tipo) {
        if (tipo === 0) {
            return icone_casa;
        } else if (tipo === 1) {
            return icone_loja;
        } else if (tipo == 2) {
            return icone_subestacao;
        }
    }

    const LocalComponent = ({ id_instalacao, lat, lng, onClick, tipo_icone, nome_mapa, status, instalacao }) => {
        const [showMenu, setShowMenu] = useState(false);

        let statusText;
        let statusColor;
        let isBlinking = false;
        let backgroundColor;

        const status_central = instalacao.status_central;

        // Calcular a diferença de tempo
        const now = new Date();
        const lastResponse = new Date(instalacao.data_hora_ultima_resposta);
        const differenceInMinutes = (now - lastResponse) / 1000 / 60; // Convertendo de milissegundos para minutos

        if (status_central === 2) {
            statusText = "ALARME";
            statusColor = "#ef4444";
            backgroundColor = "rgba(239, 68, 68, 0.1)";
            isBlinking = true;
        } else if (differenceInMinutes < 3) {
            if (status_central === 1) {
                statusText = "ONLINE - ARMADA";
                statusColor = "#10b981";
                backgroundColor = "rgba(16, 185, 129, 0.1)";
            }
            else {
                statusText = "ONLINE - DESARMADA";
                statusColor = "#f59e0b";
                backgroundColor = "rgba(245, 158, 11, 0.1)";
            }
        } else {
            statusText = "OFFLINE";
            statusColor = "#8b5cf6";
            backgroundColor = "rgba(139, 92, 246, 0.1)";
            isBlinking = true;
        }




        const handleClickGerenciar = () => {
            const url = `/gestao/administracao/clientes/gerenciarcliente/instalacao/gerenciarinstalacao/${id_instalacao}/0`;
            window.open(url, '_blank');
            setShowMenu(!showMenu);
        };



        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '12px',
                    width: '100%',
                    minHeight: '140px',
                    background: backgroundColor,
                    backdropFilter: 'blur(10px)',
                    border: `1px solid ${statusColor}40`,
                    borderRadius: '16px',
                    boxShadow: isBlinking ? `0 0 15px ${statusColor}80` : `0 4px 10px rgba(0,0,0,0.3)`,
                    animation: isBlinking && status_central === 2 ? 'pulse-red-neon 2s infinite ease-in-out' : 'none',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    position: 'relative',
                    overflow: 'hidden',
                    cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = `0 8px 20px ${statusColor}60`;
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'none';
                    e.currentTarget.style.boxShadow = isBlinking ? `0 0 15px ${statusColor}80` : `0 4px 10px rgba(0,0,0,0.3)`;
                }}
            >
                {/* Glow accent bar at the top */}
                <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '4px', backgroundColor: statusColor, opacity: 0.8 }} />

                <Grid container direction="row" alignItems="center" style={{ marginBottom: '12px', zIndex: 2 }}>
                    <img
                        alt={"icone"}
                        style={{ width: '28px', height: '28px', marginRight: '10px', filter: 'drop-shadow(0 0 4px rgba(255,255,255,0.4))' }}
                        src={processarIconeInstalacao(tipo_icone)}
                    />
                    <IconButton color="primary" onClick={handleClickGerenciar} style={{ padding: 0, flexGrow: 1, justifyContent: 'flex-start' }}>
                        <span style={{ 
                            fontSize: "14px", 
                            color: darkMode ? "#fff" : "#1e293b", 
                            fontWeight: 700, 
                            fontFamily: '"Inter", sans-serif', 
                            letterSpacing: '0.5px', 
                            textShadow: '0 2px 4px rgba(0,0,0,0.8)' 
                        }}>
                            {nome_mapa.length > 16 ? nome_mapa.substring(0, 16) + "..." : nome_mapa}
                        </span>
                    </IconButton>
                </Grid>

                {/* Equipamentos */}
                <div style={{ 
                    display: 'flex', 
                    flexWrap: 'wrap', 
                    gap: '8px', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    flexGrow: 1, 
                    zIndex: 2 
                }}>
                    {instalacao.equipamentos.map((equipamento) => {
                        return (
                            equipamento && equipamento.tipo_equipamento_area_tecnica === 0 && equipamento.modulo_pgm.id_modulo_pgm > 0 ? (
                                <ModuloPGMComponent key={equipamento.id_equipamento} tipo={equipamento.tipo_equipamento_area_tecnica} equipamento={equipamento} id_instalacao={instalacao.id_instalacao} flag={0} flag2={false} />
                            ) :
                            equipamento && equipamento.tipo_equipamento_area_tecnica === 70 ? (
                                <CentralComponent key={equipamento.id_equipamento} tipo={equipamento.tipo_equipamento_area_tecnica} equipamento={equipamento} id_instalacao={instalacao.id_instalacao} flag={0} />
                            ) :
                            equipamento && equipamento.tipo_equipamento_area_tecnica === 30 ? (
                                <ModuloSonoroComponent
                                    key={equipamento.id_equipamento}
                                    tipo={equipamento.tipo_equipamento_area_tecnica}
                                    equipamento={equipamento}
                                    id_instalacao={instalacao.id_instalacao}
                                    flag={0}
                                    handleOpenGraficoDisponibilidade={() => {
                                        setInstalacaoSelecionada(instalacao);
                                        setOpenGraficoDisponibilidade(true);
                                    }}
                                />
                            ) : null
                        );
                    })}
                </div>
                
                {/* Imagem de Fundo (se armada) opcional, com baixa opacidade para não brigar com o design */}
                {status_central === 1 && (
                    <div style={{
                        position: 'absolute',
                        right: '-20px',
                        bottom: '-20px',
                        width: '100px',
                        height: '100px',
                        backgroundImage: `url(${icone_local_protegido})`,
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        opacity: 0.15,
                        zIndex: 1,
                        pointerEvents: 'none'
                    }} />
                )}
            </div>
        );
    };

    const [logsPgm, setLogsPgm] = useState([]);
    const [limit, setLimit] = useState(100);


    const processarDadosLogs = (dados) => {
        return dados.map((item) => ({
            ...item, // Mantém os outros atributos
            data_hora_requisicao: moment(item.data_hora_requisicao).isValid()
                ? moment(item.data_hora_requisicao).format('HH:mm:ss DD/MM/YYYY')
                : item.data_hora_requisicao, // Formata a data ou mantém o valor original
            data_hora_resposta: moment(item.data_hora_resposta).isValid()
                ? moment(item.data_hora_resposta).format('HH:mm:ss DD/MM/YYYY')
                : item.data_hora_resposta, // Formata a data ou mantém o valor original
            tipo_requisicao: tipoRequisicaoMap[item.tipo_requisicao] || "Tipo Desconhecido", // Mapeia o tipo
            origem: item.origem === 0 ? "Local" : "Remoto", // Mapeia a origem
            respondido_modulo_pgm: respondidoModuloPgmMap[item.respondido_modulo_pgm] || "Status Desconhecido", // Mapeia o status de respondido
        }));
    };

    // Exemplo de como usar


    const ModuloPGMComponent = ({ lat, lng, tipo, onClick, status, equipamento, perimetro, id_instalacao, flag, flag2 }) => {


        async function handleClickLog() {
            setLogsPgm([]);


            console.log("handleClickPgm")
            try {
                const cadastro = {};
                const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
                const url = `/v1/protected/modulopgm/tarefas/listartodasparaareatecnica/` + Cookies.get("id_usuario") + "/" + equipamento.modulo_pgm.id_modulo_pgm + "/" + limit;
                const response = await api.get(url, { headers });

                if (response.data) {
                    const dadosProcessados = processarDadosLogs(response.data);

                    setLogsPgm(dadosProcessados);
                    setOpenLogTable(true);
                }

            } catch (error) {
                console.error("Erro ao enviar o comando:", error);
            }
        }

        async function handleClickPgm(comando) {

            console.log("handleClickPgm")
            try {
                const cadastro = {};
                const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
                const url = `/v1/protected/modulopgm/tarefas/criarporareatecnica/` + Cookies.get("id_usuario") + "/" + equipamento.modulo_pgm.id_modulo_pgm + "/" + comando;
                const response = await api.get(url, { headers });

                if (response.data) {
                    setSnackbarMessage('Comando Enviado!');
                    setSnackbarSeverity('success');
                    setSnackbarOpen(true);

                    // Adicionando um atraso de 3 segundos
                    setTimeout(() => {
                        handleInstalacaoSelecioanada(instalacaoSelecionada);
                    }, 5000); // 3000 milissegundos = 3 segundos
                }



            } catch (error) {
                setSnackbarMessage('Erro ao enviar comando');
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
                console.error("Erro ao enviar o comando:", error);
            }
        }

        const processarIndexAtivarRele = (index) => {
            if (index === 1) {
                //rele 1
                return 1;
            } else if (index === 2) {
                //rele 2
                return 2;
            } else if (index === 3) {
                //rele 3
                return -1;
            } else if (index === 4) {
                //rele 4
                return -1;
            }
        }

        const processarIndexDesativarRele = (index) => {
            if (index === 1) {
                //rele 1
                return 4;
            } else if (index === 2) {
                //rele 2
                return 5;
            } else if (index === 3) {
                //rele 3
                return -1;
            } else if (index === 4) {
                //rele 4
                return -2;
            }
        }

        // Calcular a diferença de tempo
        const now = new Date();
        const lastResponse = new Date(equipamento.modulo_pgm.data_hora_ultima_resposta);
        const differenceInMinutes = (now - lastResponse) / 1000 / 60; // Convertendo de milissegundos para minutos

        // Verificar se o alarme deve ser ativado
        const alarme = equipamento.alarme;

        // Definir o estado do equipamento
        let statusText;
        let statusColor;
        let isBlinking = false;

        const armada = equipamento.modulo_pgm.armada;

        if (alarme) {
            statusText = "ALARME";
            statusColor = "red";
            isBlinking = true; // Habilitar o piscar se estiver em alarme
        } else if (differenceInMinutes < 3) {
            if (armada) {
                statusText = "ONLINE - ARMADA";
                statusColor = "green";
            }
            else {
                statusText = "ONLINE - DESARMADA";
                statusColor = "orange";
            }
        } else {
            statusText = "OFFLINE";
            statusColor = "red";
            isBlinking = true; // Habilitar o piscar se estiver offline
        }




        return (
            <Grid
                container
                direction="row"
                justifyContent="center"
                align="center"
                item xs={flag === 0 ? false : 12}
                style={{ 
                    border: flag === 1 ? '1px solid #334155' : '1px solid rgba(255,255,255,0.05)', 
                    padding: flag === 0 ? '6px 4px' : '1px', 
                    margin: flag === 1 ? 3 : 0,
                    backgroundColor: flag === 0 ? (darkMode ? 'rgba(0,0,0,0.3)' : 'rgba(255,255,255,0.7)') : 'transparent',
                    borderRadius: flag === 0 ? '8px' : '0',
                    width: flag === 0 ? 'auto' : '100%',
                    minWidth: flag === 0 ? '55px' : 'auto'
                }}

            >
                {
                    flag === 1 && (
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            align="center"
                            item xs={12}
                            style={{ padding: 1 }}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                align="center"
                                item xs={11}
                                style={{ padding: 0 }}
                            >
                                <span style={{ fontWeight: 'bold', fontSize: 12, color: darkMode ? '#fff' : '#1e293b' }}>TITANIWM MODULO PGM</span>
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                align="center"
                                item xs={1}
                                style={{ padding: 0 }}
                            >
                                <button
                                    onClick={() => handleClickLog()} // Função de fechar
                                    style={{
                                        backgroundColor: 'green', // Cor laranja-avermelhada estilosa (TOP!)
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '8px',
                                        padding: '2px 8px',
                                        fontSize: '12px',
                                        cursor: 'pointer',
                                        fontWeight: 'bold',
                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', // Sombra leve
                                        textTransform: 'uppercase',
                                    }}
                                >
                                    LOG
                                </button>
                            </Grid>

                        </Grid>
                    )
                }
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    align="center"
                    item xs={flag === 0 ? 12 : 2}
                    style={{
                        boxShadow: alarme && flag === 0 ? `0 0 30px 150px rgba(255, 0, 0, 0.5)` : "none", // Sombra afastada e translúcida
                    }}>
                    <Grid item xs={12}>
                        <img
                            alt={"icone"}
                            style={{
                                textAlign: 'center',
                                width: '24px',
                                height: '24px',
                                filter: flag === 0 ? 'drop-shadow(0 0 2px rgba(255,255,255,0.5))' : 'none'
                            }}
                            src={processarIcone(tipo)}

                        />
                    </Grid>

                    <Grid item xs={12}>
                        <span style={{ color: flag === 0 ? '#cbd5e1' : 'black', fontSize: '10px', fontWeight: 'bold', fontFamily: '"Inter", sans-serif' }}>{equipamento.modulo_pgm.codigo} </span>
                    </Grid>


                    {
                        flag2 && (
                            <Grid item xs={12}
                            >
                                <span style={{
                                    color: statusColor,
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    animation: isBlinking && flag === 0 ? 'blink 2s step-start infinite' : 'none'
                                }}>
                                    {flag === 0 ? statusText : ''}
                                </span>

                            </Grid>
                        )
                    }




                </Grid>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    align="flex-start"
                    item xs={flag === 0 ? 1 : 8}
                >
                    {flag === 1 && (
                        <div style={{
                            color: 'black', fontSize: '14px', fontWeight: 'bold',
                            display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px'
                        }}>
                            {[1, 2, 3, 4].map((index) => {
                                const releNome = equipamento?.modulo_pgm[`nome_rele${index}`];
                                const status = equipamento?.modulo_pgm[`status_rele${index}`];
                                const iconPath = status === "on" ? switch_on : switch_off;

                                return (
                                    <div key={index} style={{
                                        border: '1px solid black',
                                        borderRadius: '4px', padding: '1px', display: 'flex', alignItems: 'center', backgroundColor: 'white',
                                    }}>
                                        <span>{releNome}</span>
                                        {status === "on" ? (
                                            <IconButton color="error" onClick={() => { handleClickPgm(processarIndexDesativarRele(index)) }}>
                                                <img src={iconPath} alt={`${status} icon`} style={{ width: '20px', height: '20px', marginLeft: '1px' }} />
                                            </IconButton>
                                        ) : (
                                            <IconButton color="primary" onClick={() => { handleClickPgm(processarIndexAtivarRele(index)) }}>
                                                <img src={iconPath} alt={`${status} icon`} style={{ width: '20px', height: '20px', marginLeft: '1px' }} />
                                            </IconButton>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </Grid>
            </Grid>
        );
    };




    const ModuloSonoroComponent = ({ lat, lng, tipo, onClick, status, equipamento, perimetro, id_instalacao, flag }) => {

        return (
            <Grid
                container
                direction="row"
                justifyContent="center"
                align="center"
                item xs={flag === 0 ? false : 12}
                style={{ 
                    border: flag === 1 ? '1px solid #334155' : '1px solid rgba(255,255,255,0.05)', 
                    padding: flag === 0 ? '6px 4px' : '1px', 
                    margin: flag === 1 ? 3 : 0,
                    backgroundColor: flag === 0 ? (darkMode ? 'rgba(0,0,0,0.3)' : 'rgba(255,255,255,0.7)') : 'transparent',
                    borderRadius: flag === 0 ? '8px' : '0',
                    width: flag === 0 ? 'auto' : '100%',
                    minWidth: flag === 0 ? '45px' : 'auto'
                }}

            >
                {
                    flag === 1 && (
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            align="center"
                            item xs={12}
                            style={{ padding: 1 }}
                        >
                            <span style={{ fontWeight: 'bold', fontSize: 12 }}>TITANIWM MODULO UNIFIER</span>
                        </Grid>
                    )
                }
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    align="center"
                    item xs={12}


                >
                    <Grid item xs={12}

                    >
                        <img
                            alt={"icone"}
                            style={{
                                textAlign: 'center',
                                width: flag === 0 ? '24px' : '40px',
                                height: flag === 0 ? '24px' : '40px',
                                filter: flag === 0 ? 'drop-shadow(0 0 2px rgba(255,255,255,0.5))' : 'none'
                            }}
                            src={processarIcone(tipo)}
                        />
                    </Grid>



                </Grid>
            </Grid>
        );
    };


    const CentralComponent = ({ lat, lng, tipo, onClick, status, equipamento, perimetro, id_instalacao, flag }) => {



        async function handleClickCentral(comando) {

            console.log("handleClickPgm")
            try {
                const cadastro = {};
                const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
                const url = `/v1/protected/modulopgm/tarefas/criarporareatecnica/` + Cookies.get("id_usuario") + "/" + equipamento.modulo_pgm.id_modulo_pgm + "/" + comando;
                const response = await api.get(url, { headers });

                if (response.data) {
                    setSnackbarMessage('Comando Enviado!');
                    setSnackbarSeverity('success');
                    setSnackbarOpen(true);

                    // Adicionando um atraso de 3 segundos
                    setTimeout(() => {
                        handleInstalacaoSelecioanada(instalacaoSelecionada);
                    }, 5000); // 3000 milissegundos = 3 segundos
                }



            } catch (error) {
                setSnackbarMessage('Erro ao enviar comando');
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
                console.error("Erro ao enviar o comando:", error);
            }
        }

        return (
            <Grid
                container
                direction="row"
                justifyContent="center"
                align="center"
                item xs={flag === 0 ? false : 12}
                style={{ 
                    border: flag === 1 ? '1px solid #334155' : '1px solid rgba(255,255,255,0.05)', 
                    padding: flag === 0 ? '6px 4px' : '1px', 
                    margin: flag === 1 ? 3 : 0,
                    backgroundColor: flag === 0 ? (darkMode ? 'rgba(0,0,0,0.3)' : 'rgba(255,255,255,0.7)') : 'transparent',
                    borderRadius: flag === 0 ? '8px' : '0',
                    width: flag === 0 ? 'auto' : '100%',
                    minWidth: flag === 0 ? '45px' : 'auto'
                }}


            >
                {
                    flag === 1 && (
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            align="center"
                            item xs={12}
                            style={{ padding: 1 }}
                        >
                            <span style={{ fontWeight: 'bold', fontSize: 12 }}>CENTRAL DE ALARME</span>
                        </Grid>
                    )
                }
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    align="center"

                    item xs={flag === 0 ? 12 : 2}
                >
                    <Grid item xs={12}

                    >
                        <img
                            alt={"icone"}
                            style={{
                                textAlign: 'center',
                                width: flag === 0 ? '24px' : '40px',
                                height: flag === 0 ? '24px' : '40px',
                                filter: flag === 0 ? 'drop-shadow(0 0 2px rgba(255,255,255,0.5))' : 'none'
                            }}
                            src={processarIcone(tipo)}
                        />
                    </Grid>



                </Grid>

                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    align="flex-start"
                    item xs={flag === 0 ? 1 : 8}
                >
                    {flag === 1 && (
                        <div style={{
                            color: 'black',
                            display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px'
                        }}>

                            <div style={{
                                border: '1px solid black',
                                borderRadius: '4px', padding: '1px', display: 'flex', alignItems: 'center', backgroundColor: 'white',
                            }}>
                                <IconButton color="error" onClick={() => { handleClickCentral(27) }}  >
                                    <img src={icone_armar_stay} style={{ width: '20px', height: '20px', marginLeft: '1px' }} />
                                    <span style={{ fontSize: 12, color: 'black' }}>Armar em Stay</span>
                                </IconButton>
                            </div>


                            <div style={{
                                border: '1px solid black',
                                borderRadius: '4px', padding: '1px', display: 'flex', alignItems: 'center', backgroundColor: 'white',
                            }}>
                                <IconButton color="error" onClick={() => { handleClickCentral(28) }}  >
                                    <img src={icone_armar_away} style={{ width: '20px', height: '20px', marginLeft: '1px' }} />
                                    <span style={{ fontSize: 12, color: 'black' }}>Armar em Away</span>
                                </IconButton>
                            </div>

                            <div style={{
                                border: '1px solid black',
                                borderRadius: '4px', padding: '1px', display: 'flex', alignItems: 'center', backgroundColor: 'white',
                            }}>
                                <IconButton color="error" onClick={() => { handleClickCentral(29) }}  >
                                    <img src={icone_desarmar} style={{ width: '20px', height: '20px', marginLeft: '1px' }} />
                                    <span style={{ fontSize: 12, color: 'black' }}>Desarmar</span>
                                </IconButton>
                            </div>

                        </div>
                    )}
                </Grid>

            </Grid>
        );
    };


    const CornetaComponent = ({ lat, lng, tipo, onClick, status, equipamento, perimetro, id_instalacao, flag }) => {




        async function handleClickCorneta(comando) {

            console.log("handleClickPgm")
            try {
                const cadastro = {};
                const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
                const url = `/v1/protected/modulopgm/tarefas/criarporareatecnica/` + Cookies.get("id_usuario") + "/" + equipamento.modulo_pgm.id_modulo_pgm + "/" + comando;
                const response = await api.get(url, { headers });

                if (response.data) {
                    setSnackbarMessage('Comando Enviado!');
                    setSnackbarSeverity('success');
                    setSnackbarOpen(true);

                    // Adicionando um atraso de 3 segundos
                    setTimeout(() => {
                        handleInstalacaoSelecioanada(instalacaoSelecionada);
                    }, 5000); // 3000 milissegundos = 3 segundos
                }



            } catch (error) {
                setSnackbarMessage('Erro ao enviar comando');
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
                console.error("Erro ao enviar o comando:", error);
            }
        }

        return (
            <Grid
                container
                direction="row"
                justifyContent="center"
                align="center"
                item xs={flag === 0 ? 3 : 12}
                style={{ border: flag === 1 ? '1px solid black' : null, padding: 1, margin: flag === 1 ? 3 : 0 }}


            >
                {
                    flag === 1 && (
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            align="center"
                            item xs={12}
                            style={{ padding: 1 }}
                        >
                            <span style={{ fontWeight: 'bold', fontSize: 12 }}>CORNETA KHOMP</span>
                        </Grid>
                    )
                }
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    align="flex-start"

                    item xs={flag === 0 ? 12 : 2}
                >
                    <Grid item xs={12}

                    >
                        <img
                            alt={"icone"}
                            style={{
                                textAlign: 'center',
                                width: '40px',  // Define a largura da imagem
                                height: '40px'  // Define a altura da imagem
                            }}
                            src={processarIcone(tipo)}
                        />
                    </Grid>



                </Grid>

                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    align="flex-start"
                    item xs={flag === 0 ? 1 : 8}
                >
                    {flag === 1 && (
                        <div style={{
                            color: 'black',
                            display: 'flex', alignItems: 'center', gap: '1px', marginTop: '1px'
                        }}>

                            <div style={{
                                border: '1px solid black',
                                borderRadius: '4px', padding: '1px', display: 'flex', alignItems: 'center', backgroundColor: 'white',
                            }}>
                                <IconButton color="error" onClick={() => { handleClickCorneta(6) }}  >
                                    <img src={icone_play} style={{ width: '20px', height: '20px', marginLeft: '1px' }} />
                                    <span style={{ fontSize: 12, color: 'black' }}>Audio 1</span>
                                </IconButton>
                            </div>

                            <div style={{
                                border: '1px solid black',
                                borderRadius: '4px', padding: '1px', display: 'flex', alignItems: 'center', backgroundColor: 'white',
                            }}>
                                <IconButton color="error" onClick={() => { handleClickCorneta(7) }}  >
                                    <img src={icone_play} style={{ width: '20px', height: '20px', marginLeft: '1px' }} />
                                    <span style={{ fontSize: 12, color: 'black' }}>Audio 2</span>
                                </IconButton>
                            </div>


                            <div style={{
                                border: '1px solid black',
                                borderRadius: '4px', padding: '1px', display: 'flex', alignItems: 'center', backgroundColor: 'white',
                            }}>
                                <IconButton color="error" onClick={() => { handleClickCorneta(8) }}  >
                                    <img src={icone_play} style={{ width: '20px', height: '20px', marginLeft: '1px' }} />
                                    <span style={{ fontSize: 12, color: 'black' }}>Audio 3</span>
                                </IconButton>
                            </div>

                            <div style={{
                                border: '1px solid black',
                                borderRadius: '4px', padding: '1px', display: 'flex', alignItems: 'center', backgroundColor: 'white',
                            }}>
                                <IconButton color="error" onClick={() => { handleClickCorneta(9) }}  >
                                    <img src={icone_play} style={{ width: '20px', height: '20px', marginLeft: '1px' }} />
                                    <span style={{ fontSize: 12, color: 'black' }}>Audio 4</span>
                                </IconButton>
                            </div>






                        </div>
                    )}
                </Grid>

            </Grid>
        );
    };



    const [lastUpdateTime, setLastUpdateTime] = useState(Date.now());


    const [isConnected, setIsConnected] = useState(false);

    const [numEquipamentos, setNumEquipamentos] = useState(0);

    useEffect(() => {
        let isComponentMounted = true;
        let client = null;

        const connectToWebSocket = async () => {
            const token = Cookies.get('token');
            const idUsuario = Cookies.get('id_usuario');
            const regra = Cookies.get('regra') || '';

            let idCliente = null;
            try {
                const headers = { Authorization: 'Bearer ' + token };
                const response = await api.get(`/v1/protected/user/retornardadosusuario/${idUsuario}`, { headers });
                
                if (response.data && response.data.cliente && response.data.cliente.id_cliente) {
                    idCliente = response.data.cliente.id_cliente;
                }
            } catch (error) {
                console.log("Erro ao buscar dados do cliente", error);
            }

            if (!isComponentMounted) return;

            const socket = new WebSocket(`wss://gruporosinetos.com/api/monitoramentowebsocket?token=${token}`);
            client = Stomp.over(socket);

            if (!isConnected) {
                client.connect({}, () => {
                    if (!isComponentMounted) {
                        client.disconnect();
                        return;
                    }
                    setIsConnected(true);
                    console.log('Conectado ao WebSocket');

                    let waitingNextRequest = false;

                    const sendDest = idCliente ? `/app/operacao/requestData/cliente/${idCliente}` : "/app/operacao/requestData";
                    const topicDest = idCliente ? `/topic/operacao/dados/cliente/${idCliente}` : "/topic/operacao/dados";

                    let nextTimer = null;
                    const scheduleNext = (delayMs = 4000) => {
                        if (nextTimer) clearTimeout(nextTimer);
                        nextTimer = setTimeout(() => {
                            waitingNextRequest = false;
                            sendRequest();
                        }, delayMs);
                    };

                    const sendRequest = () => {
                        if (client && client.connected && !waitingNextRequest) {
                            waitingNextRequest = true;
                            try {
                                client.send(sendDest, {}, JSON.stringify({}));
                            } catch (e) {
                                waitingNextRequest = false;
                                scheduleNext(5000);
                            }
                        }
                    };

                    client.subscribe(topicDest, (message) => {
                        try {
                            const raw = JSON.parse(message.body);
                            const lista = extrairInstalacoes(raw);
                            if (isComponentMounted && Array.isArray(lista)) {
                                setInstalacoes(lista);
                                setLoadingInstalacoes(false);
                            }
                        } catch (err) {
                            console.error("[MOSAICO] Erro ao processar dados de Operacao:", err);
                        } finally {
                            scheduleNext(4000);
                        }
                    });
                    sendRequest();
                    return; // encerra configuracao antiga do subscribe
                    // Bloco legado mantido para compatibilidade:
                    client.subscribe(topicDest, (message) => {
                    // Aqui você pode tratar a mensagem recebida
                    //console.log('Dados recebidos:', message.body);
                    console.log("atualizou");
                    let num_equipamentos = 0;
                    try {
                        const dados = JSON.parse(message.body); // Parse do JSON recebido
                        var num_equipamentos_armados = 0;
                        var num_equipamentos_alarmados = 0;
                        var num_equipamentos_desarmados = 0;
                        var num_equipamentos_offlines = 0;
                        const now = new Date();

                        // Percorre cada instalação
                        for (let i = 0; i < dados.length; i++) {
                            const novaInstalacao = dados[i];

                            if (novaInstalacao.equipamentos !== null) {


                                for (let p = 0; p < novaInstalacao.equipamentos.length; p++) {

                                    const novoEquipamento = novaInstalacao.equipamentos[p];
                                    // Verifica se o ID do equipamento ou status do alarme mudaram
                                    if (novoEquipamento.tipo_equipamento_area_tecnica === 0
                                    ) {

                                        const lastResponse = new Date(novoEquipamento.modulo_pgm.data_hora_ultima_resposta);
                                        const differenceInMinutes = (now - lastResponse) / 1000 / 60; // Convertendo de milissegundos para minutos

                                        const alarme = novoEquipamento.alarme;
                                        const armada = novoEquipamento.modulo_pgm.armada;

                                        if (alarme) {
                                            //statusText = "ALARME";
                                            num_equipamentos_alarmados++;
                                        } else if (differenceInMinutes < tempoInativo) {
                                            if (armada) {
                                                // statusText = "ONLINE - ARMADA";
                                                num_equipamentos_armados++;
                                            }
                                            else {
                                                //  statusText = "ONLINE - DESARMADA";
                                                num_equipamentos_desarmados++;
                                            }
                                        } else {
                                            // statusText = "OFFLINE";
                                            num_equipamentos_offlines++;
                                        }



                                    }

                                }

                                //fazer ossets
                                setPgmsArmadas(num_equipamentos_armados);
                                setPgmsDesarmadas(num_equipamentos_desarmados);
                                setPgmsOfflines(num_equipamentos_offlines);
                                setPgmsAlarmadas(num_equipamentos_alarmados);
                            }
                        }
                        const currentTime = Date.now();


                        // Função para verificar alterações profundas nas instalações e equipamentos
                        const dadosSaoDiferentes = (novosDados, dadosAtuais) => {
                            if (novosDados.length !== dadosAtuais.length) return true;

                            // Percorre cada instalação
                            for (let i = 0; i < novosDados.length; i++) {
                                const novaInstalacao = novosDados[i];
                                const instalacaoAtual = dadosAtuais[i];

                                if (instalacaoSelecionadaRef.current) {
                                    if (novaInstalacao.id_instalacao === instalacaoSelecionadaRef.current.id_instalacao) {
                                        //alert("Atualiuzar instalacao selecionada");
                                        setInstalacaoSelecionada({
                                            ...instalacaoSelecionadaRef.current,
                                            equipamentos: novaInstalacao.equipamentos // Substitui o array de equipamentos
                                        });
                                    }
                                }

                                // Verifica se o ID ou outra propriedade relevante da instalação mudou
                                if (novaInstalacao.id_instalacao !== instalacaoAtual.id_instalacao ||
                                    novaInstalacao.nome_mapa !== instalacaoAtual.nome_mapa) {

                                    if (instalacaoSelecionadaRef.current) {
                                        if (novaInstalacao.id_instalacao === instalacaoSelecionadaRef.current.id_instalacao) {
                                            //alert("Atualiuzar instalacao selecionada");
                                            setInstalacaoSelecionada({
                                                ...instalacaoSelecionadaRef.current,
                                                equipamentos: novaInstalacao.equipamentos // Substitui o array de equipamentos
                                            });
                                        }
                                    }


                                    return true;
                                }

                                // Verifica se o número de equipamentos mudou
                                if (novaInstalacao.equipamentos.length !== instalacaoAtual.equipamentos.length) return true;
                                num_equipamentos += novaInstalacao.equipamentos.length;
                                // Percorre cada equipamento da instalação

                                if (novaInstalacao.equipamentos !== null) {
                                    for (let j = 0; j < novaInstalacao.equipamentos.length; j++) {

                                        const novoEquipamento = novaInstalacao.equipamentos[j];
                                        const equipamentoAtual = instalacaoAtual.equipamentos[j];

                                        // Verifica se o ID do equipamento ou status do alarme mudaram

                                        if (novoEquipamento.id_equipamento !== equipamentoAtual.id_equipamento ||
                                            novoEquipamento.alarme !== equipamentoAtual.alarme) {

                                            if (instalacaoSelecionadaRef.current) {
                                                if (novaInstalacao.id_instalacao === instalacaoSelecionadaRef.current.id_instalacao) {
                                                    //alert("Atualiuzar instalacao selecionada");
                                                    setInstalacaoSelecionada({
                                                        ...instalacaoSelecionadaRef.current,
                                                        equipamentos: novaInstalacao.equipamentos // Substitui o array de equipamentos
                                                    });
                                                }
                                            }

                                            return true;
                                        }

                                        // Se o equipamento é do tipo modulo_pgm, verifica os status dos relés
                                        if (novoEquipamento.tipo_equipamento_area_tecnica === 0) {
                                            // Verifica status_rele1 até status_rele4
                                            for (let k = 1; k <= 4; k++) {
                                                const releKey = `status_rele${k}`;
                                                if (novoEquipamento.modulo_pgm[releKey] !== equipamentoAtual.modulo_pgm[releKey]) {

                                                    if (instalacaoSelecionadaRef.current) {
                                                        if (novaInstalacao.id_instalacao === instalacaoSelecionadaRef.current.id_instalacao) {
                                                            //alert("Atualiuzar instalacao selecionada");
                                                            setInstalacaoSelecionada({
                                                                ...instalacaoSelecionadaRef.current,
                                                                equipamentos: novaInstalacao.equipamentos // Substitui o array de equipamentos
                                                            });
                                                        }
                                                    }

                                                    return true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            setNumEquipamentos(num_equipamentos);
                            // Se nenhuma diferença foi encontrada
                            return false;
                        };

                        setInstalacoes((instalacoesAtuais) => {
                            const shouldUpdate =
                                dadosSaoDiferentes(dados, instalacoesAtuais) ||
                                (currentTime - lastUpdateTime > 30000); // Verifica se passaram 30 segundos

                            if (shouldUpdate) {
                                setLastUpdateTime(currentTime); // Atualiza o tempo da última atualização
                                return dados; // Atualiza o estado com os novos dados
                            }
                            return instalacoesAtuais; // Mantém o estado inalterado se não houver mudanças
                        });

                    } catch (error) {
                        console.error('Erro ao fazer parse dos dados:', error);
                    }
                    setLoadingInstalacoes(false);


                });

                // Configurar envio a cada 2 segundos
                const intervalId = setInterval(() => {
                    if (client.connected) {
                        waitingNextRequest = false;
                        sendRequest();
                    }
                }, 2000);

            }, (error) => {
                console.error('Erro ao conectar ao WebSocket:', error);
            });
        }
        };

        connectToWebSocket();

        // Limpeza da conexão quando o componente for desmontado
        return () => {
            isComponentMounted = false;
            if (client && client.connected) {
                client.disconnect(() => {
                    console.log('Desconectado do WebSocket');
                });
            }
        };
    }, []); // O array vazio garante que isso será executado uma única vez


    const [searchTerm, setSearchTerm] = useState("");
    const [filtroStatus, setFiltroStatus] = useState("TODOS");

    const handleFiltrarPorCabecalho = (tipo) => {
        setFiltroStatus((atual) => {
            let proximo = "TODOS";
            const t = (tipo || "").toLowerCase();
            if (t === "protegido" || t === "protegida") proximo = "PROTEGIDA";
            else if (t === "inseguro" || t === "desarmado" || t === "desarmada") proximo = "DESARMADA";
            else if (t === "offline" || t === "desconectada" || t === "desconectado") proximo = "DESCONECTADA";
            else if (t === "alarme" || t === "alarmada" || t === "em alarme") proximo = "ALARME";

            // Toggle: se clicar no mesmo que ja esta ativo, volta para TODOS
            return atual === proximo ? "TODOS" : proximo;
        });
    };


    function returnDescricaoEndereco(objeto) {

        return objeto.logradouro + ", " + objeto.numero + ", bairro: " + objeto.bairro + " Complemento: " + objeto.complemento +
            "\n" + objeto.cidade + " UF: " + objeto.estado + " CEP: " + objeto.cep

    }

    const filteredInstalacoes = useMemo(() => {
        let result = instalacoesEnriquecidas;
        if (filtroStatus && filtroStatus !== "TODOS") {
            result = result.filter(inst => inst.status_geral === filtroStatus);
        }
        if (searchTerm && searchTerm.trim()) {
            const term = searchTerm.trim().toLowerCase();
            result = result.filter(inst => inst.search_index && inst.search_index.includes(term));
        }
        return result;
    }, [instalacoesEnriquecidas, filtroStatus, searchTerm]);

    const [openLogTable, setOpenLogTable] = useState(false);


    const tipoRequisicaoMap = {
        0: "Acionar Ambos Reles",
        1: "Acionar Rele 1",
        2: "Acionar Rele 2",
        3: "Desligar Ambos Reles",
        4: "Desligar Rele 1",
        5: "Desligar Rele 2",
        6: "Reproduzir Audio Personalizado 1",
        7: "Reproduzir Audio Personalizado 2",
        8: "Reproduzir Audio Personalizado 3",
        9: "Reproduzir Audio Personalizado 4",
        10: "Reproduzir Audio Personalizado 5",
        20: "Desativar Automação Geral",
        21: "Ativar Automação Geral",
        22: "Reiniciar PGM",
        23: "Desativar Automação dos Reles",
        24: "Ativar Automação dos Reles",
        25: "Desativar Automação da Corneta",
        26: "Ativar Automação da Corneta",
        27: "Armar Central em Stay",
        28: "Armar Central em Away",
        29: "Desativar Central",
        50: "Central Armada",
        51: "Central Desarmada",
        52: "Central em Alarme",
        90: "Camera Agent DVR Alarme",
        15: "Controle de Volume do Modulo Unifier",
        40: "Arme do Modulo Unifier",
        41: "Desarme do Modulo Unifier",
        92: "Reconhecimento Facial"
    };

    const respondidoModuloPgmMap = {
        0: "Não Respondido",
        1: "Respondido"
    };

    const colunasLogsPgm = useMemo(
        () => [
            {
                accessorKey: 'id_tarefa',
                header: 'ID',
                size: 30,
            },
            {
                accessorKey: 'data_hora_requisicao',
                header: 'Data Requisição',
                size: 200,
            },
            {
                accessorKey: 'data_hora_resposta',
                header: 'Data Resposta',
                size: 200,
            },
            {
                accessorKey: 'tipo_requisicao',
                header: 'Tipo',
                size: 200,
            },
            {
                accessorKey: 'origem',
                header: 'Origem',
                size: 200,
            },
            {
                accessorKey: 'respondido_modulo_pgm',
                header: 'Respondido',
                size: 200,
            },
        ],
        [],
    );



    const options = {
        mapTypeId: 'satellite',
        streetViewControl: false, // Desativa o Street View
        fullscreenControl: false, // Desativa o controle de tela cheia
        mapTypeControl: false, // Desativa a opção de alterar o tipo de mapa
        zoomControl: true, // Ativa somente o controle de zoom
        maxZoom: 21,
        styles: [
            {
                featureType: "poi", // Oculta pontos de interesse
                elementType: "labels",
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "road", // Simplicidade nas rodovias
                elementType: "labels",
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "transit", // Remove transporte público
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "administrative.land_parcel", // Remove labels de terrenos
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "administrative.neighborhood", // Remove labels de bairros
                stylers: [{ visibility: "off" }],
            },
        ],
    };



    const containerStyle = {
        width: '100%',
        height: '100%'
    };



    const [map, setMap] = useState();
    const mapRef = useRef(null);

    const [lat, setLat] = useState();
    const [lng, setLng] = useState();

    const [zoom, setZoom] = useState(15);


    return (
        <div style={{ backgroundColor: darkMode ? '#0b0f19' : '#f5f5f5', minHeight: '100vh', width: '100vw', padding: '20px', fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif', overflowX: 'hidden' }}>
            <style dangerouslySetInnerHTML={{ __html: `
                @keyframes pulse-red-neon {
                    0% { box-shadow: 0 0 5px rgba(239, 68, 68, 0.4), inset 0 0 5px rgba(239, 68, 68, 0.2); border-color: rgba(239, 68, 68, 0.5); }
                    50% { box-shadow: 0 0 20px rgba(239, 68, 68, 0.8), inset 0 0 15px rgba(239, 68, 68, 0.4); border-color: rgba(239, 68, 68, 1); }
                    100% { box-shadow: 0 0 5px rgba(239, 68, 68, 0.4), inset 0 0 5px rgba(239, 68, 68, 0.2); border-color: rgba(239, 68, 68, 0.5); }
                }
            `}} />

            <div 
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    zIndex: 9999,
                    height: isHoveringNav ? 'auto' : '20px',
                    overflow: isHoveringNav ? 'visible' : 'hidden',
                    transition: 'all 0.3s ease-in-out',
                    backgroundColor: darkMode ? 'transparent' : 'white',
                }}
                onMouseEnter={() => setIsHoveringNav(true)}
                onMouseLeave={() => setIsHoveringNav(false)}
            >
                <div style={{ 
                    transform: isHoveringNav ? 'translateY(0)' : 'translateY(-100%)',
                    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    opacity: isHoveringNav ? 1 : 0
                }}>
                    <NavegadorGestao />
                </div>
                {!isHoveringNav && (
                    <div style={{ 
                        position: 'absolute', 
                        top: 0, 
                        left: '50%', 
                        transform: 'translateX(-50%)', 
                        width: '150px', 
                        height: '4px', 
                        backgroundColor: 'rgba(72, 209, 204, 0.4)', 
                        borderRadius: '0 0 8px 8px',
                        boxShadow: '0 2px 10px rgba(72, 209, 204, 0.5)'
                    }} />
                )}
            </div>

            {loading ?
                <Skeleton animation={"wave"} style={{ backgroundColor: '#48D1CC' }}>
                </Skeleton>
                :

                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    item xs={12}
                    style={{ marginTop: '20px' }}
                >

                                        {/* Componente Integrado: Cabecalho Compacto com Borda Colorida + Barra de Pesquisa */}
                    <Grid item xs={12} sx={{ px: 2, mb: 2 }}>
                        <Box sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 1.5,
                            p: 1.5,
                            borderRadius: '12px',
                            background: darkMode ? '#111827' : '#ffffff',
                            border: `1px solid ${darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}`,
                            boxShadow: darkMode ? '0 4px 20px rgba(0,0,0,0.4)' : '0 2px 10px rgba(0,0,0,0.04)'
                        }}>
                            {/* 4 Blocos Compactos do Cabecalho com Borda na Cor do Status */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                {[
                                    {
                                        label: 'PROTEGIDOS',
                                        value: 'PROTEGIDA',
                                        count: snapshot.total_protegidas,
                                        color: '#10b981',
                                        icon: <SecurityIcon sx={{ fontSize: 18 }} />
                                    },
                                    {
                                        label: 'DESARMADOS',
                                        value: 'DESARMADA',
                                        count: snapshot.total_desarmadas,
                                        color: '#f59e0b',
                                        icon: <SensorsIcon sx={{ fontSize: 18 }} />
                                    },
                                    {
                                        label: 'DESCONECTADOS',
                                        value: 'DESCONECTADA',
                                        count: snapshot.total_desconectadas,
                                        color: '#8b5cf6',
                                        icon: <SignalCellularConnectedNoInternet4BarIcon sx={{ fontSize: 18 }} />
                                    },
                                    {
                                        label: 'EM ALARME',
                                        value: 'ALARME',
                                        count: snapshot.total_em_alarme,
                                        color: '#ef4444',
                                        icon: <NotificationsActiveIcon sx={{ fontSize: 18 }} />,
                                        isAlarm: snapshot.total_em_alarme > 0
                                    }
                                ].map((item) => {
                                    const ativo = filtroStatus === item.value;
                                    return (
                                        <Box
                                            key={item.value}
                                            onClick={() => handleFiltrarPorCabecalho(item.value)}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                px: 1.4,
                                                py: 0.6,
                                                borderRadius: '9px',
                                                cursor: 'pointer',
                                                border: `2px solid ${item.color}`,
                                                backgroundColor: ativo
                                                    ? `${item.color}25`
                                                    : (darkMode ? `${item.color}10` : `${item.color}08`),
                                                boxShadow: ativo
                                                    ? `0 0 12px ${item.color}50`
                                                    : (darkMode ? '0 2px 6px rgba(0,0,0,0.3)' : '0 1px 4px rgba(0,0,0,0.05)'),
                                                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                                ...(item.isAlarm && {
                                                    animation: 'pulse-alarm-header 1.5s infinite ease-in-out'
                                                }),
                                                '&:hover': {
                                                    transform: 'translateY(-1px)',
                                                    backgroundColor: `${item.color}20`,
                                                    boxShadow: `0 4px 12px ${item.color}40`
                                                }
                                            }}
                                        >
                                            <Box sx={{
                                                color: item.color,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                {item.icon}
                                            </Box>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
                                                <Typography sx={{
                                                    fontSize: '1.05rem',
                                                    fontWeight: 900,
                                                    color: darkMode ? '#f8fafc' : '#0f172a',
                                                    fontFamily: 'monospace',
                                                    lineHeight: 1
                                                }}>
                                                    {item.count || 0}
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '0.62rem',
                                                    fontWeight: 800,
                                                    color: item.color,
                                                    letterSpacing: '0.5px',
                                                    lineHeight: 1.1,
                                                    mt: 0.2
                                                }}>
                                                    {item.label}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    );
                                })}

                                {(filtroStatus !== 'TODOS' || searchTerm) && (
                                    <Button
                                        size="small"
                                        onClick={() => {
                                            setFiltroStatus('TODOS');
                                            setSearchTerm('');
                                        }}
                                        sx={{
                                            fontSize: '0.74rem',
                                            textTransform: 'none',
                                            fontWeight: 700,
                                            color: darkMode ? '#94a3b8' : '#64748b',
                                            ml: 0.5,
                                            px: 1,
                                            py: 0.4,
                                            borderRadius: '6px',
                                            border: `1px solid ${darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
                                            '&:hover': { color: '#ef4444', borderColor: '#ef4444' }
                                        }}
                                    >
                                        Limpar filtros
                                    </Button>
                                )}
                            </Box>

                            {/* Campo de Pesquisa + Indicador de Resultados */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: '1 1 320px', justifyContent: 'flex-end', minWidth: '260px' }}>
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    placeholder="Buscar instalação, cliente, endereço, PGM..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    sx={{ flex: '1 1 240px', maxWidth: '420px' }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon sx={{ color: darkMode ? '#94a3b8' : '#64748b', fontSize: 19 }} />
                                            </InputAdornment>
                                        ),
                                        endAdornment: searchTerm ? (
                                            <InputAdornment position="end">
                                                <IconButton size="small" onClick={() => setSearchTerm('')} sx={{ p: 0.5 }}>
                                                    <ClearIcon sx={{ fontSize: 17, color: darkMode ? '#94a3b8' : '#64748b' }} />
                                                </IconButton>
                                            </InputAdornment>
                                        ) : null,
                                        sx: {
                                            borderRadius: '8px',
                                            backgroundColor: darkMode ? '#1f2937' : '#f8fafc',
                                            color: darkMode ? '#f8fafc' : '#0f172a',
                                            fontSize: '0.84rem',
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'
                                            },
                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: darkMode ? '#38bdf8' : '#0284c7'
                                            }
                                        }
                                    }}
                                />

                                <Typography sx={{
                                    fontSize: '0.76rem',
                                    fontWeight: 700,
                                    color: darkMode ? '#94a3b8' : '#64748b',
                                    fontFamily: 'monospace',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {filteredInstalacoes ? filteredInstalacoes.length : 0} de {snapshot.total_instalacoes || 0}
                                </Typography>
                            </Box>
                        </Box>
                        
                        {/* Keyframes de pulso para o cabecalho e alarme dos cards */}
                        <style dangerouslySetInnerHTML={{ __html: `
                            @keyframes pulse-alarm-header {
                                0%, 100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.4); border-color: #ef4444; }
                                50% { box-shadow: 0 0 10px 2px rgba(239, 68, 68, 0.7); border-color: #f87171; }
                            }
                            @keyframes blink-alarm-card {
                                0%, 100% {
                                    border-color: #ef4444 !important;
                                    box-shadow: 0 0 16px rgba(239, 68, 68, 0.75), inset 0 0 8px rgba(239, 68, 68, 0.25) !important;
                                }
                                50% {
                                    border-color: #7f1d1d !important;
                                    box-shadow: 0 0 2px rgba(239, 68, 68, 0.15) !important;
                                }
                            }
                        `}} />
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        alignItems="flex-start"
                        item xs={12}
                    >
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            align="center"
                            item xs={12}
                        >
                            {!loadingInstalacoes && filteredInstalacoes && filteredInstalacoes.map((inst) => {
                                const isSelected = instalacaoSelecionada?.id_instalacao === inst.id_instalacao;
                                const isDesconectada = inst.status_geral === "DESCONECTADA";
                                const isAlarme = inst.status_geral === "ALARME";
                                const statusColor = inst.status_geral === "PROTEGIDA" ? "#10b981" :
                                                    inst.status_geral === "DESARMADA" ? "#f59e0b" :
                                                    isDesconectada ? "#8b5cf6" : "#ef4444";

                                const cardBorder = isDesconectada ? '3.5px solid #8b5cf6' :
                                                   isAlarme ? '3.5px solid #ef4444' :
                                                   `2px solid ${statusColor}`;

                                return (
                                    <Grid
                                        key={inst.id_instalacao}
                                        item
                                        xs={12} sm={6} md={4} lg={3} xl={2}
                                        style={{ padding: '8px' }}
                                    >
                                        <MuiPaper
                                            elevation={0}
                                            onClick={() => handleInstalacaoSelecioanada(inst)}
                                            style={{
                                                backgroundColor: isSelected 
                                                    ? (darkMode ? '#1e3a5f' : '#e0f2fe') 
                                                    : (darkMode ? '#1e293b' : '#ffffff'),
                                                color: darkMode ? '#f8fafc' : '#0f172a',
                                                border: cardBorder,
                                                borderRadius: '10px',
                                                padding: '9px 12px',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                boxShadow: isSelected 
                                                    ? `0 0 0 2px ${statusColor}, 0 6px 16px rgba(0,0,0,0.35)` 
                                                    : (isDesconectada ? `0 4px 12px rgba(139, 92, 246, 0.25)` :
                                                       isAlarme ? `0 0 16px rgba(239, 68, 68, 0.6)` :
                                                       (darkMode ? '0 3px 10px rgba(0,0,0,0.35)' : '0 2px 6px rgba(0,0,0,0.06)'))
                                            }}
                                            sx={{
                                                borderRadius: '10px',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                ...(isAlarme && {
                                                    animation: 'blink-alarm-card 1.2s infinite ease-in-out'
                                                }),
                                                '&:hover': {
                                                    boxShadow: `0 6px 16px ${statusColor}60`,
                                                    transform: 'translateY(-1px)',
                                                    backgroundColor: darkMode ? '#24334a' : '#f8fafc'
                                                }
                                            }}
                                        >
                                            {/* Linha 1: Status Badge + Codigo dos Modulos + Ultima Resposta */}
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 0.8, mb: 0.6, flexWrap: 'wrap' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, flexWrap: 'wrap' }}>
                                                    <Chip
                                                        label={inst.status_geral}
                                                        size="small"
                                                        sx={{
                                                            fontSize: '0.65rem',
                                                            fontWeight: 800,
                                                            height: '20px',
                                                            backgroundColor: `${statusColor}22`,
                                                            color: statusColor,
                                                            border: `1.5px solid ${statusColor}`
                                                        }}
                                                    />
                                                    {inst.codigo_pgm && (
                                                        <Chip
                                                            label={`PGM: ${inst.codigo_pgm}`}
                                                            size="small"
                                                            sx={{
                                                                fontSize: '0.65rem',
                                                                fontWeight: 700,
                                                                height: '20px',
                                                                backgroundColor: darkMode ? '#0f172a' : '#f1f5f9',
                                                                color: darkMode ? '#e2e8f0' : '#1e293b',
                                                                border: `1px solid ${darkMode ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.12)'}`
                                                            }}
                                                        />
                                                    )}
                                                    {inst.codigo_sonoro && (
                                                        <Chip
                                                            icon={<VolumeUpIcon style={{ fontSize: 12, color: '#38bdf8' }} />}
                                                            label={`Sonoro: ${inst.codigo_sonoro}`}
                                                            size="small"
                                                            sx={{
                                                                fontSize: '0.65rem',
                                                                fontWeight: 700,
                                                                height: '20px',
                                                                backgroundColor: darkMode ? '#0c2238' : '#e0f2fe',
                                                                color: darkMode ? '#7dd3fc' : '#0369a1',
                                                                border: `1px solid ${darkMode ? 'rgba(56, 189, 248, 0.3)' : 'rgba(3, 105, 161, 0.25)'}`
                                                            }}
                                                        />
                                                    )}
                                                </Box>

                                                {/* Ultima resposta com letra bem menor e discreta */}
                                                <Typography
                                                    sx={{
                                                        fontSize: '0.50rem',
                                                        letterSpacing: '0.1px',
                                                        color: darkMode ? '#94a3b8' : '#64748b',
                                                        lineHeight: 1.1,
                                                        whiteSpace: 'nowrap',
                                                        ml: 'auto'
                                                    }}
                                                >
                                                    Últ. Resp: <span style={{ fontWeight: 600, color: darkMode ? '#cbd5e1' : '#334155' }}>{formatarDataHora(inst.data_hora_pgm)}</span>
                                                    {inst.tem_modulo_sonoro && (
                                                        <span style={{ marginLeft: 4 }}>
                                                            | Sonoro: <span style={{ fontWeight: 600, color: darkMode ? '#cbd5e1' : '#334155' }}>{formatarDataHora(inst.data_hora_sonoro)}</span>
                                                        </span>
                                                    )}
                                                </Typography>
                                            </Box>

                                            {/* Linha 2: Nome da Instalacao + Botoes de Acao e Chamada */}
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 0.5 }}>
                                                <Typography
                                                    sx={{
                                                        fontWeight: 800,
                                                        fontSize: '0.92rem',
                                                        color: darkMode ? '#ffffff' : '#0f172a',
                                                        lineHeight: 1.25,
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        flex: 1
                                                    }}
                                                    title={inst.nome_mapa}
                                                >
                                                    {inst.nome_mapa || `Instalação #${inst.id_instalacao}`}
                                                </Typography>

                                                {/* Botoes de Acao + Botao de Chamada */}
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, flexShrink: 0 }}>
                                                    {/* Botao de Chamada para Ramal */}
                                                    {inst.ramal && (
                                                        <Tooltip title={`Ligar para ramal ${inst.ramal}`}>
                                                            <Button
                                                                size="small"
                                                                startIcon={<CallIcon sx={{ fontSize: 13, color: darkMode ? '#34d399' : '#10b981' }} />}
                                                                onClick={(e) => handleSipCall(inst.ramal, e)}
                                                                sx={{
                                                                    py: 0.15,
                                                                    px: 0.7,
                                                                    fontSize: '0.68rem',
                                                                    fontWeight: 800,
                                                                    fontFamily: 'monospace',
                                                                    textTransform: 'none',
                                                                    backgroundColor: darkMode ? 'rgba(16, 185, 129, 0.22)' : 'rgba(16, 185, 129, 0.15)',
                                                                    color: darkMode ? '#ffffff !important' : '#047857 !important',
                                                                    border: `1px solid ${darkMode ? '#34d399' : '#10b981'}`,
                                                                    borderRadius: '5px',
                                                                    minWidth: 'auto',
                                                                    height: '24px',
                                                                    '&:hover': {
                                                                        backgroundColor: '#10b981',
                                                                        color: '#ffffff !important'
                                                                    }
                                                                }}
                                                            >
                                                                <span style={{ color: darkMode ? '#ffffff' : '#047857', fontWeight: 800 }}>
                                                                    {inst.ramal}
                                                                </span>
                                                            </Button>
                                                        </Tooltip>
                                                    )}

                                                    {/* 1) Botao Painel da Instalacao */}
                                                    <Tooltip title="Abrir painel da instalação">
                                                        <IconButton
                                                            size="small"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleInstalacaoSelecioanada(inst);
                                                            }}
                                                            sx={{
                                                                width: 24,
                                                                height: 24,
                                                                color: darkMode ? '#38bdf8' : '#0284c7',
                                                                backgroundColor: darkMode ? 'rgba(56, 189, 248, 0.12)' : 'rgba(2, 132, 199, 0.08)',
                                                                border: `1px solid ${darkMode ? 'rgba(56, 189, 248, 0.25)' : 'rgba(2, 132, 199, 0.2)'}`,
                                                                borderRadius: '5px',
                                                                p: 0,
                                                                '&:hover': {
                                                                    backgroundColor: darkMode ? 'rgba(56, 189, 248, 0.25)' : 'rgba(2, 132, 199, 0.18)',
                                                                }
                                                            }}
                                                        >
                                                            <DashboardIcon sx={{ fontSize: 14 }} />
                                                        </IconButton>
                                                    </Tooltip>

                                                    {/* 2) Botao Ver no mapa */}
                                                    <Tooltip title="Ver no mapa">
                                                        <IconButton
                                                            size="small"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                window.open(`/tecnica/monitoramento/mapa`, '_blank');
                                                            }}
                                                            sx={{
                                                                width: 24,
                                                                height: 24,
                                                                color: darkMode ? '#94a3b8' : '#64748b',
                                                                backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.04)',
                                                                border: `1px solid ${darkMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'}`,
                                                                borderRadius: '5px',
                                                                p: 0,
                                                                '&:hover': {
                                                                    color: '#0284c7',
                                                                    borderColor: '#0284c7',
                                                                    backgroundColor: 'rgba(2, 132, 199, 0.12)',
                                                                }
                                                            }}
                                                        >
                                                            <LocationOnIcon sx={{ fontSize: 14 }} />
                                                        </IconButton>
                                                    </Tooltip>

                                                    {/* 3) Botao Gerenciar */}
                                                    <Tooltip title="Gerenciar instalação">
                                                        <IconButton
                                                            size="small"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                window.open(`/gestao/administracao/clientes/gerenciarcliente/instalacao/gerenciarinstalacao/${inst.id_instalacao}/0`, '_blank');
                                                            }}
                                                            sx={{
                                                                width: 24,
                                                                height: 24,
                                                                color: darkMode ? '#f59e0b' : '#d97706',
                                                                backgroundColor: darkMode ? 'rgba(245, 158, 11, 0.12)' : 'rgba(217, 119, 6, 0.08)',
                                                                border: `1px solid ${darkMode ? 'rgba(245, 158, 11, 0.25)' : 'rgba(217, 119, 6, 0.2)'}`,
                                                                borderRadius: '5px',
                                                                p: 0,
                                                                '&:hover': {
                                                                    backgroundColor: darkMode ? 'rgba(245, 158, 11, 0.25)' : 'rgba(217, 119, 6, 0.18)',
                                                                }
                                                            }}
                                                        >
                                                            <ManageAccountsIcon sx={{ fontSize: 14 }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            </Box>

                                            {/* Linha 3: Localizacao */}
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}>
                                                <LocationOnIcon sx={{ fontSize: 15, color: statusColor, flexShrink: 0 }} />
                                                <Typography
                                                    sx={{
                                                        fontSize: '0.73rem',
                                                        color: darkMode ? '#94a3b8' : '#64748b',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        fontWeight: 500
                                                    }}
                                                >
                                                    {inst.bairro ? `${inst.bairro}${inst.cidade ? ` - ${inst.cidade}` : ''}` : (inst.identificador_integrador ? `${inst.identificador_integrador}` : 'Localização não informada')}
                                                </Typography>
                                            </Box>
                                        </MuiPaper>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Grid>
                </Grid>
            }

            {instalacaoSelecionada && (
                <PainelInstalacaoDetalhes
                    instalacaoSelecionada={instalacaoSelecionada}
                    setInstalacaoSelecionada={setInstalacaoSelecionada}
                    larguraOriginal={window.innerWidth}
                    limiar={900}
                    darkMode={darkMode}
                    activeCallRamal={activeCallRamal}
                    handleSipHangup={handleSipHangup}
                    handleSipCall={handleSipCall}
                    returnDescricaoEndereco={returnDescricaoEndereco}
                    handleOpenGraficoDisponibilidade={() => setOpenGraficoDisponibilidade(true)}
                    useNativeCall={true}
                    toggleSipMode={() => {}}
                    sipStatus={sipStatus}
                    handleOpenMosaicoDisponibilidade={() => {}}
                    handleOpenMosaico={() => {}}
                    openMosaico={false}
                    closeMosaico={() => {}}
                    cameras={[]}
                    urlStream={null}
                    openMosaicoDisponibilidade={false}
                    closeMosaicoDisponibilidade={() => {}}
                />
            )}

            {/* Modal Gráfico de Disponibilidade */}
            {openGraficoDisponibilidade && instalacaoSelecionada && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 99999 }}>
                    <GraficoDisponibilidade
                        idInstalacao={instalacaoSelecionada.id_instalacao}
                        instalacao={instalacaoSelecionada}
                        onClose={() => setOpenGraficoDisponibilidade(false)}
                    />
                </div>
            )}

            <audio
                ref={remoteAudioRefMosaico}
                id="remoteSipAudioMosaico"
                autoPlay
                playsInline
                style={{ position: 'fixed', top: -1000, left: -1000, opacity: 0, pointerEvents: 'none' }}
            />
        </div >
    );
}





